import React from "react";

class PasswordView extends React.Component {
  render() {
    return null;
  }
}
export default PasswordView;
